import { Role } from '@adornis/abac/policies/SimpleRolePolicy.js';
import { registerSubscription } from '@adornis/baseql/metadata/register.js';
import { subscribeAllEntitiesResolver } from '@adornis/baseql/server/resolver/mongo.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { gatePlatformUserManageSubscription } from './nexus-api/nexus-permission-gate.js';

/** Gated replacement for client `subscribeAllEntities(Role)`. */
export const subscribeAllEntitiesRoles = registerSubscription({
  operationName: 'subscribeAllEntitiesRoles',
  type: () => [Role],
  params: [],
  resolve: () => (gqlFields: BaseQLSelectionSet<Role>) =>
    gatePlatformUserManageSubscription(() => subscribeAllEntitiesResolver(Role._class)(gqlFields)),
});
